import { render, staticRenderFns } from "./Drop.vue?vue&type=template&id=833c3be0&scoped=true"
var script = {}
import style0 from "./Drop.vue?vue&type=style&index=0&id=833c3be0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "833c3be0",
  null
  
)

export default component.exports